import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["componentEl", "margin", "size", "className"];
import React from 'react';
import PropTypes from 'prop-types';

// this loads things like util functions, and also global CSS, including CSS variables
import { componentElPropTypes } from '../customPropTypes/componentEl';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes } from '../customPropTypes/spacing';
import { jsx as _jsx } from "react/jsx-runtime";
/**
This is a simple Circular Loader
*/
function Loader(_ref) {
  var Component = _ref.componentEl,
    margin = _ref.margin,
    size = _ref.size,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_loader', "st_loader--".concat(size)];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_jsx(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps));
}
process.env.NODE_ENV !== "production" ? Loader.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes,
  /** size of loader */
  size: PropTypes.oneOf(['md', 'lg', 'xl'])
} : void 0;
Loader.defaultProps = {
  componentEl: 'div',
  className: null,
  margin: null,
  size: 'xl'
};
export default Loader;